export enum NotificationAutoSuggestFields {
    TITLE = 'title',
    BODY = 'body',
    IMAGE_URL = 'image_url',
    KEYWORDS = 'keywords',
}
